import React, { Component } from "react";
import {
    Card,
    Switch,
    Button,
    InputGroup,
    FormGroup,
    Icon,
} from "@blueprintjs/core";

import {
    BASE_API,
    AppToaster,
    COLORS,
    SUBMENU, // ⬅️ pentru primul tab admin
} from "../../utils/constants";

import {setSession} from  '../../utils/helpers'

import { withRouterParams } from "../../utils/withRouterParams"; // ⬅️ injectează navigate
import UiDialog from "../../components-fm/UiDialog";
import { getSession } from "../../utils/helpers";
import "../../css/SuperAdminDashboard.scss";

class SuperAdminOrganizations extends Component {
    state = {
        organizations: [],
        loading: true,
        error: null,
        searchTerm: "",
        filter: "",
        showAddDialog: false,
        email: "",
        password: "",
        organization: "",
        errors: {
            email: "",
            password: "",
            organization: "",
        },
        isConfirmOrgDeleteOpen: false,
        organizationToBeDeleted: null,
    };

    componentDidMount() {
        console.log('Component did mont.....')
        this.getData();
    }

    /* ───────────────────────────────  API calls  ───────────────────────────── */

    async getData() {
        console.log('---------------')
        try {
            const res = await fetch(`${BASE_API}/api/admin/organizations/all`);
            const data = await res.json();
            this.setState({ organizations: data.organizations || [], loading: false });
        } catch {
            this.setState({
                error: "Eroare la încărcarea organizațiilor",
                loading: false,
            });
        }
    }

    /* ───────────────────────────  Aprobare organizație  ───────────────────── */

    toggleApproval = async (org) => {
        try {
            const res = await fetch(
                `${BASE_API}/api/admin/organizations/${org.id}/approve`,
                {
                    method: "POST",
                    body: JSON.stringify({ approved: !org.approved }),
                    headers: { "Content-Type": "application/json" },
                }
            );
            if (res.ok) {
                this.setState((prev) => ({
                    organizations: prev.organizations.map((o) =>
                        o.id === org.id ? { ...o, approved: !org.approved } : o
                    ),
                }));
            }
        } catch {
            AppToaster.show({
                message: "Eroare la schimbarea stării.",
                intent: "danger",
            });
        }
    };

    /* ───────────────────────────  Search / Filter UI  ─────────────────────── */

    handleSearch = (e) => this.setState({ searchTerm: e.target.value });
    handleFilter = (filter) => this.setState({ filter });
    toggleAddDialog = () =>
        this.setState((prev) => ({ showAddDialog: !prev.showAddDialog }));

    /* ───────────────────────────  Validare formular  ──────────────────────── */

    handleInputChange = (e) => {
        const { name, value } = e.target;
        const errors = { ...this.state.errors };

        if (name === "email") {
            errors.email = /\S+@\S+\.\S+/.test(value) ? "" : "Email invalid";
        }
        if (name === "password") {
            errors.password =
                value.length >= 6
                    ? ""
                    : "Parola trebuie să aibă cel puțin 6 caractere";
        }
        if (name === "organization") {
            errors.organization = /^[a-zA-Z0-9 \-_]+$/.test(value)
                ? ""
                : "Sunt permise doar litere, cifre, spații, precum și caracterele _ și -.";
        }

        this.setState({ [name]: value, errors });
    };

    isFormValid = () => {
        const { email, password, organization, errors } = this.state;
        return (
            email &&
            password &&
            organization &&
            !errors.email &&
            !errors.password &&
            !errors.organization
        );
    };

    /* ───────────────────────────  Adăugare organizație  ───────────────────── */

    handleAddOrganization = async () => {
        this.toggleAddDialog();
        const { email, organization, password } = this.state;

        try {
            const res = await fetch(`${BASE_API}/api/auth/signup`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password, organization }),
            });

            const data = await res.json();

            if (res.ok) {
                AppToaster.show({
                    message: "Contul a fost trimis pentru aprobare.",
                    intent: "success",
                    timeout: 3000,
                });
                this.getData();
            } else {
                AppToaster.show({
                    message: data.error || "Eroare la înregistrare.",
                    intent: "danger",
                    timeout: 5000,
                });
            }
        } catch {
            AppToaster.show({
                message: "Eroare de rețea.",
                intent: "danger",
                timeout: 5000,
            });
        }
    };

    /* ─────────────────────────────  Ștergere organizație  ─────────────────── */

    confirmOrganizationDrop = (id, name) => {
        const org = id ? { id, name } : null;
        this.setState((prev) => ({
            isConfirmOrgDeleteOpen: !prev.isConfirmOrgDeleteOpen,
            organizationToBeDeleted: org,
        }));
    };

    handleDropOrganization = async () => {
        this.confirmOrganizationDrop();
        const { organizationToBeDeleted } = this.state;
        if (!organizationToBeDeleted?.id) return;

        try {
            const res = await fetch(`${BASE_API}/api/admin/organizations`, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: organizationToBeDeleted.id }),
            });

            const data = await res.json();

            if (res.ok) {
                this.setState((prev) => ({
                    organizations: prev.organizations.filter(
                        (o) => o.id !== organizationToBeDeleted.id
                    ),
                    organizationToBeDeleted: null,
                }));
                AppToaster.show({
                    message: "Organizația a fost ștearsă cu succes.",
                    intent: "success",
                });
            } else {
                AppToaster.show({
                    message: data.error || "Eroare la ștergerea organizației.",
                    intent: "danger",
                });
            }
        } catch {
            AppToaster.show({
                message: "Eroare de rețea la ștergerea organizației.",
                intent: "danger",
            });
        }
    };

    /* ───────────────────────  Navigare către Admin-ul organizației  ───────── */

    openOrgAdmin = (org) => {
        const session = getSession();
        session.organization.id = org.id;
        session.organization.organization_slug = org.slug;
        session.organization.organization_name = org.organization_name;
        setSession(session);    
        // localStorage.setItem("session", JSON.stringify(session));

        const firstTab = SUBMENU.admin[0].slug; // "echipe"
        this.props.navigate(`/admin?org=${org.slug}&tab=${firstTab}`);


        
    };

    /* ───────────────────────────  Helpers UI  ─────────────────────────────── */

    getRandomColor() {
        const index = Math.floor(Math.random() * COLORS.length);
        return COLORS[index];
    }

    /* ───────────────────────────  Render  ─────────────────────────────── */

    render() {
        const {
            organizations,
            loading,
            error,
            searchTerm,
            email,
            organization,
            password,
            errors,
            showAddDialog,
            isConfirmOrgDeleteOpen,
            filter,
        } = this.state;

        let filtered = organizations.filter((org) =>
            org.organization_name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        if (filter === "approved") filtered = filtered.filter((o) => o.approved);
        if (filter === "unapproved") filtered = filtered.filter((o) => !o.approved);

        if (loading) return <p>Se încarcă...</p>;
        if (error) return <p>{error}</p>;

        return (
            <div className="p-2-rem p-0-ss">
                {/* Header */}
                <div className="dashboard-header">
                    {/* Filters */}
                    <div className="header-filters">
                        <Button
                            text={`Organizatii: ${organizations.length}`}
                            minimal
                            onClick={() => this.handleFilter("")}
                            className={filter === "" ? "active" : ""}
                        />
                        <Button
                            text={`Active: ${organizations.filter((o) => o.approved).length}`}
                            minimal
                            onClick={() => this.handleFilter("approved")}
                            className={filter === "approved" ? "active" : ""}
                        />
                        <Button
                            text={`Inactive: ${organizations.filter((o) => !o.approved).length
                                }`}
                            minimal
                            onClick={() => this.handleFilter("unapproved")}
                            className={filter === "unapproved" ? "active" : ""}
                        />
                    </div>

                    {/* Actions */}
                    <div className="header-actions">
                        <InputGroup
                            leftIcon="search"
                            placeholder="Caută organizație..."
                            value={searchTerm}
                            onChange={this.handleSearch}
                        />
                        <Button className="seagreen btn-medium" onClick={this.toggleAddDialog}>
                            Adaugă
                        </Button>
                    </div>
                </div>

                {/* Organizations list */}
                {filtered.length === 0 ? (
                    <p>Nu există organizații care corespund căutării.</p>
                ) : (
                    filtered.map((org) => (
                        <Card
                            key={org.id}
                            className="org-card"
                            style={{ borderLeft: `5px solid ${this.getRandomColor()}` }}
                        >
                            <div className="rel-pos">
                                <div className="org-link" onClick={() => this.openOrgAdmin(org)}>
                                    {org.organization_name}
                                </div>
                                <Icon
                                    icon="trash"
                                    onClick={() => this.confirmOrganizationDrop(org.id, org.organization_name)}
                                />
                            </div>

                            <div className="email-label">
                                Admin: <strong>{org.admin_name || "necunoscut"}</strong> 
                            </div>
                            <div className="email-label">
                                Email: <strong>{org.admin_email || "necunoscut"}</strong> 
                            </div>

                            <div className="card-actions">
                                <Switch
                                    large
                                    checked={org.approved}
                                    onChange={() => this.toggleApproval(org)}
                                />
                            </div>
                        </Card>
                    ))
                )}

                {/* Dialog: Add Organization */}
                <UiDialog
                    isOpen={showAddDialog}
                    onClose={this.toggleAddDialog}
                    title="Adaugă organizație"
                    footer={
                        <>
                            <Button className="alert-bordered btn-medium" onClick={this.toggleAddDialog}>
                                Anulează
                            </Button>
                            <Button
                                className="seagreen btn-medium"
                                onClick={this.handleAddOrganization}
                                disabled={!this.isFormValid()}
                            >
                                Salvează
                            </Button>
                        </>
                    }
                >
                    <FormGroup
                        label="Email"
                        intent={errors.email ? "danger" : "none"}
                        helperText={errors.email}
                    >
                        <InputGroup
                            name="email"
                            value={email}
                            onChange={this.handleInputChange}
                            intent={errors.email ? "danger" : "none"}
                        />
                    </FormGroup>

                    <FormGroup
                        label="Parolă"
                        intent={errors.password ? "danger" : "none"}
                        helperText={errors.password}
                    >
                        <InputGroup
                            type="password"
                            name="password"
                            value={password}
                            onChange={this.handleInputChange}
                            intent={errors.password ? "danger" : "none"}
                        />
                    </FormGroup>

                    <FormGroup
                        label="Organizație"
                        intent={errors.organization ? "danger" : "none"}
                        helperText={errors.organization}
                    >
                        <InputGroup
                            name="organization"
                            value={organization}
                            onChange={this.handleInputChange}
                            intent={errors.organization ? "danger" : "none"}
                        />
                    </FormGroup>
                </UiDialog>

                {/* Dialog: Confirm delete */}
                <UiDialog
                    isOpen={isConfirmOrgDeleteOpen}
                    onClose={this.confirmOrganizationDrop}
                    title="Șterge organizație"
                    footer={
                        <>
                            <Button className="alert-bordered btn-medium" onClick={this.confirmOrganizationDrop}>
                                Anulează
                            </Button>
                            <Button className="alert btn-medium" onClick={this.handleDropOrganization}>
                                Șterge
                            </Button>
                        </>
                    }
                >
                    <div>
                        Confirmi ștergerea organizației{" "}
                        <strong>{this.state.organizationToBeDeleted?.organization_name}</strong>?
                    </div>
                </UiDialog>
            </div>
        );
    }
}

export default withRouterParams(SuperAdminOrganizations);
